type ExchangeListsErrowRowProps = {
    message: string;
};

const ExchangeListsErrowRow: React.FC<ExchangeListsErrowRowProps> = ({ message }) => {
    return <div className='row error'>{message}</div>;
};

export default ExchangeListsErrowRow;
